import * as KlayvioService from './KlayvioService';
import * as GTMService from './GTMService';

/**
 * 
 * @param {{
 *   initial: boolean,
 *   amount: number,
 *   amount_cents: number,
 *   week: string,
 *   time_slot_id: number,
 *   delivery_date: string,
 *   meals_array: Array<{
 *     sku: string,
 *     image: string,
 *     price: number,
 *     price_cents: number,
 *     quantity: number,
 *     name: string,
 *   }>,
 * }} data 
 */
const trackPreselections = (data) => {
  KlayvioService.trackPreselections(data);
  GTMService.trackPreselections(data);
}

export {
  trackPreselections,
}